import {CardModel, CardUserModel, CardSortOrder} from "@/models/card.model";
import { cardService } from "../../services/card.service";
import store from "../store";

// tslint:disable-next-line:typedef
const state = {
    cardsOnPinBoard: JSON.parse(localStorage.getItem("cardsOnPinBoard") as string) ||  [] as CardModel[],
    cardUsersOnPinBoard: JSON.parse(localStorage.getItem("cardUsersOnPinBoard") as string) ||  [] as CardUserModel[],
};

// tslint:disable-next-line:typedef
const getters = {
    getCardsOnPinBoard: (cardState: any) => {
        return cardState.cardsOnPinBoard;
    },
    getCardUsersOnPinBoard: (cardState: any) => {
        return cardState.cardUsersOnPinBoard;
    },
    getCardUsersOnPinBoardByCardId: (cardState: any) => (cardId: number) => {
        return (cardState.cardUsersOnPinBoard as CardUserModel[]).filter((j) => j.cardId === cardId);
    },
};

// tslint:disable-next-line:typedef
const actions = {
    getCardsOnPinBoard: async ({commit, dispatch}: {commit: any, dispatch: any}, pinBoardId: number) => {
        const result = await cardService.getAllByPinBoardId(pinBoardId);
        if (result != null){
            result.forEach((card:CardModel, index:number) => {
                card.sortOrder = card.sortOrder != null ? card.sortOrder : index;
                
            });
            commit("mSetCardsOnPinBoard", result);
            commit("mSetCardUsersOnPinBoard", result);
            return true;
        }
        return false;
    },
    setCardAvailability: async ({commit, dispatch}: {commit: any, dispatch: any}, card: CardModel) => {
        const result = await cardService.setAvailability({  cardId: card.id, availability: card.isAvailable });
        if (result != null){
            commit("mSetCardAvailability", card);
            return true;
        }
        return false;
    },
    moveCardUser: async ({commit, dispatch}: {commit: any, dispatch: any}, cardUserInfo: any) => {
        commit("mMoveCardUser", cardUserInfo);
        const result = await cardService
        .moveCardUser({ id: cardUserInfo.cardUserId, newCardId: cardUserInfo.newCardId });
    },
    clearCardState: async ({commit, dispatch}: {commit: any, dispatch: any}) => {
        commit("mClearCardState");
        return true;
    },
    updateCardsOrder: async ({commit, dispatch}: {commit: any, dispatch: any}, list:CardModel[]) => {
        const sortCardSortOrderList = list.map(c => ({ id:c.id, newSortOrder: c.sortOrder } as CardSortOrder));
        let result = await cardService.updateCardsSortOrder(store.getters["app/currentPinBoardId"], sortCardSortOrderList);
        if(result){
            commit("mSetCardsOnPinBoard", list);
        }
    },
};

// tslint:disable-next-line:typedef
const mutations = {
    mSetCardsOnPinBoard:(cardState: any, cards: CardModel[]) => {
        cardState.cardsOnPinBoard = cards;
        localStorage.setItem("cardsOnPinBoard", JSON.stringify(cards));
    },
    mSetCardUsersOnPinBoard:(cardState:any, cards: CardModel[]) => {
        const cardUserList = [] as CardUserModel[];

        cards.forEach(card => {
            if(card.cardUsers!.length > 0) {
                card.cardUsers!.forEach(cardUser => {
                    cardUserList.push(
                        {
                            id: cardUser.id,
                            cardId: card.id,
                            email: cardUser.email,
                            firstName: cardUser.firstName,
                            lastName: cardUser.lastName,
                            phone: cardUser.phone,
                            image: cardUser.image,
                            cardUserId: cardUser.cardUserId,
                        } as CardUserModel);
                });
            }
        });

        cardState.cardUsersOnPinBoard = cardUserList;
        localStorage.setItem("cardUsersOnPinBoard", JSON.stringify(cardState.cardUsersOnPinBoard));
    },
    mMoveCardUser: (cardState: any, cardUserInfo: any) => {


        (cardState.cardUsersOnPinBoard as CardUserModel[])
            .find(j => j.cardUserId === cardUserInfo.cardUserId)!.cardId = cardUserInfo.newCardId;
        localStorage.setItem("cardUsersOnPinBoard", JSON.stringify(cardState.cardUsersOnPinBoard));
    },
    mSetCardAvailability: (cardState: any, card:any) => {
        let tmpList = cardState.cardsOnPinBoard as CardModel[];

        tmpList.forEach(element => {
            if(element.id === card.id) {
                element.isAvailable = card.isAvailable;
            }
        });
        cardState.cardsOnPinBoard = tmpList;
        localStorage.setItem("cardsOnPinBoard", JSON.stringify(tmpList));
    },
    mClearCardState: (cardState: any, card:any) => {
        cardState.cardsOnPinBoard = [];
        cardState.cardUsersOnPinBoard = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};